module.exports = __webpack_public_path__ + "assets/img/4-5.b07a4f66.png";